import { useEffect, useState, memo } from "react";
import PropTypes from "prop-types";

const ProgressiveImage = (props) => {
    const { src, placeholder, className, imageRef, onClick } = props; // Destructure เพื่อความสะอาด
    const [currentSrc, setCurrentSrc] = useState(placeholder);

    useEffect(() => {
        let isMounted = true; // 1. สร้างตัวแปรเช็คสถานะ

        // ถ้า src เปลี่ยน ให้ reset กลับไปเป็น placeholder ก่อน (Optional: แล้วแต่ดีไซน์)
        // setCurrentSrc(placeholder); 

        const imageToLoad = new Image();
        imageToLoad.src = src;
        
        imageToLoad.onload = () => {
            // 2. เช็คว่า component ยังอยู่ไหม ก่อน set state
            if (isMounted) {
                setCurrentSrc(src);
            }
        };

        // 3. Cleanup Function: จะทำงานเมื่อ Component ถูก Unmount หรือ src เปลี่ยน
        return () => {
            isMounted = false; // บอกว่า Component ไม่อยู่แล้ว
            imageToLoad.onload = null; // ตัดการเชื่อมต่อ event เพื่อความชัวร์
        };
    }, [src, placeholder]); // 4. แก้ dependency array ให้เช็คแค่ src กับ placeholder ไม่ใช่ทั้ง props

    return (
        <img
            src={currentSrc}
            className={["progressiveImage", className].join(" ")}
            style={{
                transition: "opacity .15s linear",
            }}
            ref={imageRef}
            onClick={onClick}
            alt="Game Thumbnail" // ควรรับเป็น props หรือทำให้สั้นลง
        />
    );
}

ProgressiveImage.propTypes = {
    src: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    className: PropTypes.string,
    imageRef: PropTypes.oneOfType([
        PropTypes.func, 
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ]),
    onClick: PropTypes.func
};

export default memo(ProgressiveImage);